import { useCallback, useState } from 'react';
import styles from './hsaForgotPassword.module.scss';
import ParentAuthPageLayout from '../../../components/auth-page-layout/HsaAuthPageLayout';
import { TextInput } from '../../../components/text-input/TextInput';
import { validateEmail } from '../../../utils/validation';
import Button from 'src/components/button/Button';
import { useHeaSendResetPasswordLinkMutation } from '@api/graphql-codegen';

type Props = {};

function HSAForgotPassword(props: Props) {
  return (
    <ParentAuthPageLayout backToLogin={true} title={'Forgot Password?'}>
      <ForgotFormContent />
    </ParentAuthPageLayout>
  );
}

const ForgotFormContent = () => {
  const [email, setEmail] = useState('');
  const [completed, setCompleted] = useState(false);
  const [clientError, setClientError] = useState<undefined | string>();

  const [sendResetPasswordLink, { loading, error }] = useHeaSendResetPasswordLinkMutation({
    onCompleted: () => {
      setCompleted(true);
    }
  });

  const handleSubmit = useCallback(async () => {
    const error = validateEmail(email);
    if (error) {
      return setClientError(error);
    }

    try {
      await sendResetPasswordLink({ variables: { input: { email } } });
    } catch (e) {
      setClientError((e as any).message);
    }
  }, [email, sendResetPasswordLink]);

  const handleChange = useCallback((value) => {
    setClientError(undefined);
    setEmail(value);
  }, []);

  return (
    <>
    {completed ?
      (<>
        {error ?(
          <div className={styles.confirm}>
            <div className={styles.confirmErrorTitle}>Error!</div>
            <div className={styles.confirmSubtitle}>{error.message}</div>
          </div>
        ) : (
          <div className={styles.confirm}>
            <div className={styles.confirmTitle}>Thank you!</div>
            <div className={styles.confirmSubtitle}>Please check your inbox for further instructions.</div>
          </div>
        )}
        </>
      ) : (
      <>
        <div className={styles.description}>
          Enter the email address associated with your account
          We will send an email to reset your password
        </div>
        <TextInput allowSpecialCharacters placeholder={'Email'} label={'Email*'} id={'email'} value={email} onChange={handleChange}/>
        {!!clientError && <div className={styles.error}>{clientError}</div>}
        <Button disabled={loading} className={styles.submit} onClick={handleSubmit} label={'Send'} />
      </>
    )}
    </>
  )
};
export default HSAForgotPassword;
